<template>
  <v-dialog v-model="dialog" persistent max-width="420">
    <v-card>
      <v-card-title class="text-h5 red--text text--darken-1">
        คุณไม่มีสิทธิ์ทำรายการนี้
      </v-card-title>

      <v-card-text>
        กรุณาตรวจสอบสิทธิ์ของคุณหรือติดต่อผู้ดูแลระบบหากต้องการความช่วยเหลือเพิ่มเติม
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="text-center" text @click="$emit('onCloseDialog')">
          ปิด
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
